<template>
  <span class="inline-flex items-center">
    <img
      :src="logoSrc"
      :class="[logoClass, themeClass]"
      alt="YouStory"
    />
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { useThemeStore } from '@/stores/theme';
import logoBlack from '@/assets/logo-black.svg';

const theme = useThemeStore();

const props = defineProps({
  /** Slightly smaller for tight layouts */
  compact: { type: Boolean, default: false },
});

const logoSrc = computed(() => logoBlack);

const logoClass = computed(() => {
  if (props.compact) return 'h-8 shrink-0';
  return 'h-10 shrink-0';
});

const themeClass = computed(() => {
  return theme.isDark ? 'logo-white' : 'logo-colored';
});
</script>

<style scoped>
/* In dark mode: invert black to white */
.logo-white {
  filter: invert(1);
}

/* In light mode: colorize black to brand violet-indigo */
.logo-colored {
  filter: invert(29%) sepia(90%) saturate(4000%) hue-rotate(252deg) brightness(90%) contrast(95%);
}
</style>
